<list-view [liste]="listeMessages" *ngIf="listeMessages"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>
